<template>
  <v-app>
    <!-- App Bar -->
    <v-app-bar
      :class="{ 'aid-nav-bar-impersonating': isImpersonating }"
      :color="getAppBarColor()"
      app
      dark
      clipped-left
      clipped-right
      v-if="showNormalAppBars()"
    >
      <v-app-bar-nav-icon
        v-if="showNormalAppBars() && !hasFreeFunctionality && !isWideScreen"
        @click.stop="normalDrawer = !normalDrawer"
      />

      <v-toolbar-title class="aid-logotype">
        AgriBus-Web
      </v-toolbar-title>

      <v-spacer />

      <v-badge bordered color="transparent" overlap>
        <template v-slot:badge v-if="hasStandardFunctionality">
          <v-img max-width="18" src="/images/icon_standardplan.png"></v-img>
        </template>
        <v-btn class="mr-1" fab icon small @click.stop="rightNormalDrawer = !rightNormalDrawer">
          <v-avatar :size="32">
            <img :src="iconUrl" />
          </v-avatar>
        </v-btn>
      </v-badge>
    </v-app-bar>

    <!-- 左ドロアー -->
    <v-navigation-drawer
      v-model="normalDrawer"
      app
      fixed
      clipped
      width="280px"
      :permanent="isWideScreen && !hasFreeFunctionality"
      :temporary="!isWideScreen"
      v-if="showNormalAppBars()"
    >
      <!-- expand: 各ツリーを独立して開閉できるようにする(アコーディオン動作の無効化) -->
      <v-list expand>
        <!-- ニュースフィード (トップページ) -->
        <v-list-item to="/feed">
          <v-list-item-icon>
            <v-icon>mdi-newspaper-variant-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ $tt('feed.menu') }}
            <span class="caption ml-1">(beta)</span>
          </v-list-item-title>
        </v-list-item>

        <!-- マップ (F4: レイヤーツリー) -->
        <v-list-item to="/map">
          <v-list-item-icon>
            <v-icon>mdi-map</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ $tt('feed.map') }}
            <span class="caption ml-1">(beta)</span>
          </v-list-item-title>
        </v-list-item>

        <!-- 作付 -->
        <v-list-group prepend-icon="eco" no-action v-model="menuGroups.planting">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="$tt('customProduct')" />
            </v-list-item-content>
          </template>
          <v-list-item to="/plantings/list">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $tt('customListDisplay') }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- 圃場 -->
        <v-list-group prepend-icon="place" no-action v-model="menuGroups.field">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="$tt('customFieldHeader')" />
            </v-list-item-content>
          </template>
          <v-list-item to="/fields/list">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $tt('customFieldsList') }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/fields/sets">
            <v-list-item-icon>
              <v-icon>mdi-select-group</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $tt('feed.mapSets') }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/fields/print">
            <v-list-item-icon>
              <v-icon>mdi-cloud-print</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $tt('print.field.printText') }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- 作業 -->
        <v-list-group prepend-icon="mdi-wrap" no-action v-model="menuGroups.task">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="$tt('feed.trajectories')" />
            </v-list-item-content>
          </template>
          <v-list-item to="/tasks/list">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $tt('customListDisplay') }}</v-list-item-title>
          </v-list-item>
          <v-list-item to="/tasks/calendar">
            <v-list-item-icon>
              <v-icon>mdi-calendar</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $tt('customCalendarDisplay') }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- 派生記録 (F5-3: 走行軌跡と一対の作業記録+編集した派生) -->
        <v-list-item to="/works">
          <v-list-item-icon>
            <v-icon>mdi-source-branch</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ $tt('DocFormTabNameTaskRecordList') }}
            <span class="caption ml-1">(beta)</span>
          </v-list-item-title>
        </v-list-item>

        <!-- VRAマップ (F5 Phase B/D: NDVI ゾーンマップ)。本番は一旦オフ -->
        <v-list-item v-if="vraMapEnabled" to="/vra">
          <v-list-item-icon>
            <v-icon>mdi-grid</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ $tt('feed.vraTitle') }}
            <span class="caption ml-1">(beta)</span>
          </v-list-item-title>
        </v-list-item>

        <!-- 高低差マップ (VRAマップと同構造・指数 ELEV) -->
        <v-list-item v-if="elevationMapEnabled" to="/elevation">
          <v-list-item-icon>
            <v-icon>mdi-terrain</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ $tt('fieldElevation.title') }}
            <span class="caption ml-1">(beta)</span>
          </v-list-item-title>
        </v-list-item>

        <!-- 基準線 -->
        <v-list-group prepend-icon="mdi-ray-start-end" no-action v-model="menuGroups.refline">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ $tt('customRefLine') }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item @click.stop="goToIfStandardFunctionality('/reflines/add')">
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $tt('customNewRegistration') }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop="goToIfStandardFunctionality('/reflines/list')">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $tt('customListDisplay') }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- 地点メモ (POI: 写真+地点の記録) -->
        <v-list-item to="/records/poi">
          <v-list-item-icon>
            <v-icon>mdi-map-marker</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ $tt('feed.poiRecords') }}
            <span class="caption ml-1">(beta)</span>
          </v-list-item-title>
        </v-list-item>

        <!--
        土壌水分
         -->
        <v-list-group prepend-icon="mdi-water" no-action v-model="menuGroups.soil">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="wrap-text">{{ $tt('observation.soilMoisture') }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/observations/pf">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $tt('customListDisplay') }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!--
        積算気温
         -->
        <v-list-group prepend-icon="mdi-thermometer-plus" no-action v-model="menuGroups.temp">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="wrap-text">{{ $tt('observation.accumulatedTemperature') }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/observations/at">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $tt('customListDisplay') }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- つながり (フィードのフォロー管理。旧レーンの /connections/* は manager 依存のため使わない) -->
        <v-list-item to="/feed/connections">
          <v-list-item-icon>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $tt('customConnectionTitle') }}</v-list-item-title>
        </v-list-item>

        <!-- マーケット情報 (AgriBus-DWH) -->
        <v-list-item to="/market-insights">
          <v-list-item-icon>
            <v-icon>mdi-chart-line</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ $tt('marketInsights.menu') }}
            <span class="caption ml-1">(beta)</span>
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click.stop="switchToNow()">
          <v-list-item-icon>
            <v-icon>mdi-crosshairs-gps</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <v-badge>
              <span class="aid-logotype">AgriBus-Now</span>
              <span class="caption ml-2">(beta)</span>
            </v-badge>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- 右ドロアー -->
    <v-navigation-drawer v-model="rightNormalDrawer" app right temporary v-if="showNormalAppBars()">
      <v-list-item two-line>
        <v-list-item-avatar size="36">
          <img :src="iconUrl" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ nickname }}
            <span v-if="isAdminUser"> <br />(Admin) </span>
            <span v-if="isImpersonating">
              <br />
              (origin::{{ impersonatingNickname }})
            </span>
          </v-list-item-title>

          <v-list-item-subtitle>{{ purchaseInfo.getI18nName() }}</v-list-item-subtitle>

          <v-switch v-model="darkMode" class="dark-mode-switch" :label="$tt('customDarkMode')" />
        </v-list-item-content>
      </v-list-item>
      <v-divider v-if="hasFreeFunctionality" />
      <v-list-item to="/free" v-if="hasFreeFunctionality">
        <v-list-item-icon>
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $tt('customHome') }}</v-list-item-title>
      </v-list-item>
      <v-divider />

      <v-list v-model="rightSelectedItem">
        <!-- 管理者メニュー -->
        <div v-if="isAdminUser">
          <v-subheader class="red--text">管理者メニュー</v-subheader>
          <v-list-item to="/app/console">
            <v-list-item-icon>
              <v-icon>build</v-icon>
            </v-list-item-icon>
            <v-list-item-title>管理</v-list-item-title>
          </v-list-item>
          <v-divider />
        </div>

        <!-- アカウント -->
        <v-subheader>{{ $vuetify.lang.t('$vuetify.customAccountHeader') }}</v-subheader>
        <v-list-item to="/user/settings">
          <v-list-item-icon>
            <v-icon>mdi-account-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $tt('customUserSettings') }}</v-list-item-title>
        </v-list-item>

        <v-list-item to="/user/passwd">
          <v-list-item-icon>
            <v-icon>mdi-lock-reset</v-icon>
          </v-list-item-icon>
          <v-list-item-title v-if="isOAuthUserAndPasswordNotEntered()"
            >{{ $tt('CreatePasswordTitle') }}
          </v-list-item-title>
          <v-list-item-title v-else>{{ $tt('ChangePasswordTitle') }}</v-list-item-title>
        </v-list-item>

        <v-list-item to="/billing" v-if="!hasFreeFunctionality">
          <v-list-item-icon>
            <v-badge color="red">
              <v-icon>mdi-credit-card-settings-outline</v-icon>
            </v-badge>
          </v-list-item-icon>
          <v-list-item-title>{{ $tt('customBillingMenu') }}</v-list-item-title>
        </v-list-item>
        <v-divider />

        <!-- Caster -->
        <v-subheader v-if="!hasFreeFunctionality">Caster</v-subheader>
        <v-list-item @click.stop="switchToCasterInfo()" v-if="!hasFreeFunctionality">
          <v-list-item-icon>
            <v-icon>mdi-radio-tower</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $tt('caster.rtkInfo') }}</v-list-item-title>
        </v-list-item>
        <v-list-item to="/caster/logs" v-if="isCasterLogAvailable">
          <v-list-item-icon>
            <v-icon>mdi-math-log</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $tt('caster.rtkLog') }}</v-list-item-title>
        </v-list-item>
        <v-divider />

        <v-list-item @click="logout()" class="mt-3">
          <v-list-item-icon>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $tt('DocFormMenuItemSignOut') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Content -->
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import ApplicationConfig from '@/lib/application-config'
import connectHttpBase from '@/lib/connect-client/connect-http-base'
import * as Constants from '@/lib/constants'
import Currency from '@/lib/currency'
import DevicesInfo from '@/lib/devices-info'
import i18n from '@/lib/i18n'
import storage from '@/lib/storage'
import UserGroupsInfo from '@/lib/user-groups-info'
import UserInfo from '@/lib/user-info'

export default {
  name: 'App',

  data() {
    return {
      darkMode: false,
      normalDrawer: false,
      rightNormalDrawer: false,
      rightSelectedItem: 0,
      color: '',
      purchaseInfo: this.$store.getters.purchaseInfo,
      mini: false,
      appBar: false,
      isShowDrawer: false,
      menuGroups: this.loadMenuGroups(),
    }
  },

  watch: {
    darkMode: function(val) {
      this.$vuetify.theme.dark = this.darkMode
    },
    menuGroups: {
      deep: true,
      handler(val) {
        localStorage.setItem('drawer.menuGroups', JSON.stringify(val))
      },
    },
    userInfo: function(val) {
      // FIXME 作業履歴の作付けフィルター初期表示不具合の修正コード
      // もっと良いタイミングで行いたい
      // this.$store.dispatch('initProducts')
      this.purchaseInfo = storage.getPurchaseInfo()
      this.setGTagUserProperties()
    },
  },

  computed: {
    isCasterLogAvailable() {
      return false
    },
    vraMapEnabled() {
      return ApplicationConfig.isVraMapEnabled()
    },
    elevationMapEnabled() {
      return ApplicationConfig.isElevationMapEnabled()
    },
    // 横長の大きい画面ではナビドロワーを常設の左カラムにする (施策F R18)
    isWideScreen() {
      return this.$vuetify.breakpoint.lgAndUp
    },
    changeBar() {
      return this.$vuetify.breakpoint.mdAndDown
    },
    currencyIconClass() {
      return Currency.getCurrencyIconClass()
    },
    // FIXME
    connectGroupEnabled() {
      return ApplicationConfig.CONNECT_GROUP_ENABLED
    },
    userInfo() {
      return UserInfo.get()
    },
    nickname() {
      return UserInfo.getNickname()
    },
    iconUrl() {
      return UserInfo.getIconUrl()
    },
    incomingSubscriptionRequestsLength() {
      return this.$store.getters.incomingSubscriptionRequests.length
    },
    isAdminUser() {
      return UserInfo.isAdmin()
    },
    isImpersonating() {
      return UserInfo.isImpersonating()
    },
    impersonatingNickname() {
      return UserInfo.getImpersonatingNickname()
    },
    myDevices() {
      return DevicesInfo.devices() //FIXME
    },
    hasStandardFunctionality() {
      return UserInfo.hasStandardFunctionality()
    },
    hasFreeFunctionality() {
      return UserInfo.hasFreeFunctionality()
    },
    drawer: {
      get() {
        return this.isShowDrawer || !this.$vuetify.breakpoint.mdAndDown
      },
      set(status) {
        this.isShowDrawer = status
      },
    },
    canShowBillingMenu() {
      if ('agribus.test@gmail.com' === UserInfo.getEmail()) {
        return false
      }
      return true
    },
  },

  methods: {
    loadMenuGroups() {
      // ドロワーのツリー開閉状態を復元 (既定は作付・圃場のみ開)
      const defaults = { planting: true, field: true, task: false, refline: false, soil: false, temp: false }
      try {
        return { ...defaults, ...JSON.parse(localStorage.getItem('drawer.menuGroups')) }
      } catch (e) {
        return defaults
      }
    },
    showNormalAppBars() {
      if (connectHttpBase.isAuthenticated()) {
        if (this.$store.getters.nowShowingRealtime || this.$store.getters.showFieldPrint) {
          return false
        }
        return true
      }
      return false
    },
    logout() {
      this.$store.dispatch('logout')
    },
    resetAllDrawers() {
      this.normalDrawer = false
      this.rightNormalDrawer = false
    },
    switchToNow() {
      this.resetAllDrawers()
      this.$store.dispatch('setNowShowingRealtime', true)
      this.$router.push({ name: 'NowNow' })
    },
    switchToCasterInfo() {
      this.$router.push({ name: 'CasterInfo' })
    },
    getAppBarColor() {
      if (this.$vuetify.theme.dark) {
        return ''
      }
      return Constants.CONNECT_GREEN
    },
    isOAuthUserAndPasswordNotEntered() {
      if (UserInfo.isOAuthUser()) {
        if (!UserInfo.isPasswordEntered()) {
          return true
        }
      }
      return false
    },
    alertNeedStandardPlan() {
      const message = i18n.tt('StandardPlanIsNeededDialogMessage')
      alert(message)
    },
    goToIfStandardFunctionality(path) {
      this.$router.push({ path: path })
    },
    setGTagUserProperties() {
      const username = UserInfo.getUsername()
      if (username) {
        const purchaseInfo = storage.getPurchaseInfo()
        this.$gtag.config({
          user_id: username,
        })

        const userProperties = {}
        if (!UserInfo.hasFreeFunctionality()) {
          if (UserInfo.hasStandardFunctionality()) {
            userProperties.plan = 'Standard'
          }
          if (UserInfo.hasPlusFunctionality()) {
            userProperties.plan = 'Plus'
          }
          if (UserInfo.hasProfessionalFunctionality()) {
            userProperties.plan = 'Professional'
          }
          userProperties.trial = purchaseInfo.isTrial()
          userProperties.startedAt = purchaseInfo.getStartedAt()
          userProperties.expiredAt = purchaseInfo.getExpiredAt()
          userProperties.autoRenewing = purchaseInfo.isAutoRenewing()
        } else if (UserInfo.hasFreeFunctionality()) {
          userProperties.plan = 'Free'
        } else {
          userProperties.plan = 'Unknown'
        }
        this.$gtag.set({ user_properties: userProperties })
      }
    },
  },
}
</script>

<style>
.current-location-btn,
.polygon-edit-btn {
  bottom: 130px;
  right: 10px;
}

.delete-btn {
  bottom: 180px;
  right: 10px;
}

/* 描画中の「1点戻す」。delete-btn (確定後のみ表示) とは同時に出ないので同じ位置 */
.undo-btn {
  bottom: 180px;
  right: 10px;
}

.finish-btn {
  bottom: 240px;
  right: 10px;
}

.draw-hint {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 13px;
  max-width: calc(100% - 32px);
  text-align: center;
}

.on-map-btn {
  background-color: #fff;
  width: 40px;
  height: 40px;
  position: absolute;
  border-radius: 3px;
  padding-left: 8px;
  padding-top: 8px;
}

.on-map-btn:hover {
  cursor: pointer;
}

.vue-map-hidden {
  display: block !important;
}

.aid-opacity-07 {
  opacity: 0.7;
}

.aid-logotype {
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
}

.aid-logotype-medium {
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
}

.aid-nav-bar-impersonating {
  background-color: #ffa600 !important;
}

.aid-selected-card {
  border: 1px solid red;
}

.dark-mode-switch {
  margin-left: 11px;
}

.wrap-text {
  word-break: break-all;
  white-space: normal;
}
</style>
